export default String.raw`
.flag {
  position: relative;
  background-color: $lightestColor;
  background-image: url(../css/img/flags.png);
  display: inline-block;
  width: 31px;
  height: 19px;
  padding: 7px;
  vertical-align: text-top !important;
}

.flag-be {
  background-position: -2px -5px;
}

.flag-bg {
  background-position: -2px -27px;
}

.flag-cs {
  background-position: -2px -52px;
}

.flag-da {
  background-position: -2px -76px;
}

.flag-de{
  background-position: -2px -101px;
}

.flag-el {
  background-position: -2px -125px;
}

.flag-en {
  background-position: -2px -150px;
}

.flag-es {
  background-position: -2px -174px;
}

.flag-et {
  background-position: -2px -199px;
}

.flag-fi {
  background-position: -2px -224px;
}

.flag-fr {
  background-position: -2px -248px;
}

.flag-hr {
  background-position: -2px -273px;
}

.flag-hu {
  background-position: -2px -298px;
}

.flag-is {
  background-position: -2px -322px;
}

.flag-it {
  background-position: -2px -347px;
}

.flag-ja {
  background-position: -2px -371px;
}

.flag-ka {
  background-position: -2px -396px;
}

.flag-lt {
  background-position: -2px -421px;
}

.flag-lv {
  background-position: -2px -445px;
}

.flag-mk {
  background-position: -2px -470px;
}

.flag-nl {
  background-position: -2px -495px;
}

.flag-no {
  background-position: -2px -519px;
}

.flag-pl {
  background-position: -2px -544px;
}

.flag-pt {
  background-position: -2px -568px;
}

.flag-ro {
  background-position: -2px -593px;
}

.flag-ru {
  background-position: -2px -617px;
}

.flag-sk {
  background-position: -2px -642px;
}

.flag-sl {
  background-position: -2px -667px;
}

.flag-sq {
  background-position: -2px -691px;
}

.flag-sr {
  background-position: -2px -716px;
}

.flag-sv {
  background-position: -2px -740px;
}

.flag-tr {
  background-position: -2px -765px;
}

.flag-uk {
  background-position: -2px -790px;
}
`